export default function CsharpOperators() {
  return (
    <h2>Csharp Operators</h2>
  );
}
